// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D2NpunWrwkcTS3M61sgw{border-bottom:1px solid var(--border-neutral-default);height:48px;color:var(--content-primary-primary);align-items:center;padding-left:16px;padding-right:12px;display:flex}.CO5p2PpM0kk_Ww5_K0n_{grid-template-columns:32px 1fr max-content;align-items:center;gap:12px;width:100%;display:grid}.CO5p2PpM0kk_Ww5_K0n_ .YLevFvC1Dqs5miUWLiDf{justify-content:center;align-items:center;display:flex}.CO5p2PpM0kk_Ww5_K0n_ .CPz48UXTdkshny7Lw87Z{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `D2NpunWrwkcTS3M61sgw`,
	"checkedContent": `CO5p2PpM0kk_Ww5_K0n_`,
	"wrapCheckbox": `YLevFvC1Dqs5miUWLiDf`,
	"right": `CPz48UXTdkshny7Lw87Z`
};
export default ___CSS_LOADER_EXPORT___;
